<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    {{$t('news.template.forum.updateNumberSeats.p1')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[0]}}">
      {{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.forum.updateNumberSeats.p2')}}
    {{news.textParams[2]}}
    {{$t('news.template.forum.updateNumberSeats.p2')}}
    {{news.textParams[3]}}.
  </div>
</template>
